export const MENU_TYPE_PICKER_SET_MEAL_TYPE_ID = 'MENU_TYPE_PICKER_SET_MEAL_TYPE_ID';
export const MENU_TYPE_PICKER_SET_MEAL_TYPES = 'MENU_TYPE_PICKER_SET_MEAL_TYPES';
